import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=05c60046&scoped=true&"
import script from "./maintenance.vue?vue&type=script&lang=js&"
export * from "./maintenance.vue?vue&type=script&lang=js&"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=05c60046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c60046",
  null
  
)

export default component.exports